import { render, staticRenderFns } from "./BaseModalEx.vue?vue&type=template&id=485988f4&scoped=true"
import script from "./BaseModalEx.vue?vue&type=script&lang=js"
export * from "./BaseModalEx.vue?vue&type=script&lang=js"
import style0 from "./BaseModalEx.vue?vue&type=style&index=0&id=485988f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485988f4",
  null
  
)

export default component.exports